<h1 mat-dialog-title>{{ 'app.select-language-dialog.title' | translate }}</h1>
<mat-icon mat-dialog-close class="close">close</mat-icon>

<div mat-dialog-content>
  <nr-redirect-dropdown (onSelect)="onSelectLanguage($event)"></nr-redirect-dropdown>
</div>

<div mat-dialog-actions>
  <button
    (click)="onContinueClick()"
    mat-flat-button color="primary"
    [mat-dialog-close]="true"
    class="main-button proceed"
    [disabled]="language.length === 0"
  >{{ 'app.select-language-dialog.button' | translate }}</button>
</div>
